import { FormEventHandler, ReactNode } from "react";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import "./FiltersView.css";

const FiltersView = ({
  children,
  onReset,
  onCheckFiltersChanged,
  onSubmit,
  submitLabel,
}: {
  children: ReactNode;
  onCheckFiltersChanged: Function;
  onReset: Function;
  onSubmit: FormEventHandler<HTMLFormElement>;
  submitLabel: string;
}) => {
  return (
    <form
      className="ViewerFilterForm ViewerFilterForm__verticalLayout"
      onSubmit={onSubmit}
    >
      <div className="filters__container ViewerFilterForm__verticalLayout">
        {children}
        <div className="filterActions__container">
          <div />
          <div className="filterActions">
            <PathologyWatchButton
              onClick={() => onReset()}
              disabled={!onCheckFiltersChanged()}
            >
              Reset All Filters
            </PathologyWatchButton>
            <PathologyWatchButton type="submit" color="green">
              {submitLabel}
            </PathologyWatchButton>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FiltersView;
